module.exports = __webpack_public_path__ + "static/media/clock(gray).a36a90f1.svg";